import '../css/styles.scss';

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
import EventHandler from 'bootstrap/js/src/dom/event-handler';
import Swiper from 'swiper/bundle';
import TomSelect from 'tom-select';
import {merge, debounce, throttle} from 'lodash';
import intlTelInput from 'intl-tel-input';
import Inputmask from 'inputmask';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb'; // Number & Money formatting

import * as projectConstants from '%helpers%/constants';
import * as projectUtils from '%helpers%/utils';
import * as projectHelpers from '%helpers%/helpers';
import MultipleSelectFilter from '%modules%/filter-multiselect';

window.springEQ = window.springEQ || {};
window.springEQ.constants = window.springEQ.constants || projectConstants;
window.springEQ.helpers = {...window.springEQ.helpers, ...projectUtils, ...projectHelpers};
window.springEQ.helpers.initiateFilterMultiSelect = (el, config = {}) => new MultipleSelectFilter(el, config);

if (!window.matchMedia('(pointer:fine)').matches) document.body.classList.add('no-cursor');

import {initWidgets} from '%widgets%/widgets';
import {initiatePageLayout} from '%modules%/page-layout';
import {initBootstrapAdditions} from '%modules%/bootstrap';
import {copyTextToClipboard, initFormElements} from '%helpers%/helpers';
import Video from '%modules%/video';

initBootstrapAdditions();
initFormElements();
initiatePageLayout();
initWidgets();

document.querySelectorAll('[data-toggle="scrollTop"]').forEach(el => {
  el.addEventListener('click', event => {
    event.preventDefault();
    window.springEQ.helpers.scrollToTop();
  });
});

EventHandler.on(document, 'click.bs.modal.data-api', '[data-bs-toggle="modal-video"]', ({delegateTarget}) => {
  if (delegateTarget.closest('.swiper') && delegateTarget.closest('.swiper').swiper._moved) return;
  new Video(delegateTarget);
});

EventHandler.on(document, 'click.bs.copyText.data-api', '[data-bs-toggle="copyText"]', ({delegateTarget}) => {
  const {value, successText} = delegateTarget.dataset;

  document.querySelectorAll('[data-bs-toggle="copyText"]').forEach(el => {
    if (el !== delegateTarget) {
      const bsTooltip = bootstrap.Tooltip.getInstance(el);
      if (bsTooltip) bsTooltip.hide();
    }
  });

  if (value) copyTextToClipboard(delegateTarget, value, successText);
});
